module.exports = __webpack_public_path__ + "static/media/customStep2.2372b8a8.png";